import { defineStore } from 'pinia';
import { ref } from 'vue';
import backendApi from '../axios/backendApi';
import { useAuthStore } from './useAuthStore';
import { handleError } from '../functions/utils';

export const useEventStore = defineStore('event', () => {
    const event = ref<OfficialEvent | null>(null);
    const events = ref<OfficialEvent[]>([]);
    const registeredUsers = ref<User[]>([]);
    const participants = ref<Participant[]>([]);
    const loading = ref(false);

    const fetchEvents = async (eventType = 'officiel') => {
        const authStore = useAuthStore();
        loading.value = true;
        try {
            const { data } = await backendApi.get('/events/', {
                params: { event_type: eventType },
                headers: { Authorization: `Bearer ${authStore.token}` },
            });
            events.value = data.map((e: any) => ({
                ...e,
                date: e.event_date,
                date_end: e.event_date_end ?? null,
                place: e.location,
                organiser: e.club_name,
                organizer_club_id: e.organizer_club_id ?? null,
                affiche: e.affiche ?? null,
                format: e.format ?? null,
                price_cents: e.price_cents ?? 0,
                created_by_email: e.created_by_email ?? null,
            }));
        } catch (err) {
            handleError(err, 'récupération des events');
        } finally {
            loading.value = false;
        }
    };

    const fetchEventDetail = async (eventId: number) => {
        loading.value = true;
        try {
            const { data } = await backendApi.get(`/events/${eventId}`);
            event.value = {
                ...data,
                date: data.event_date,
                date_end: data.event_date_end ?? null,
                place: data.location,
                organiser: data.club_name,
                organizer_club_id: data.organizer_club_id ?? null,
            };
        } catch (error) {
            console.error('Error fetching event details:', error);
            throw error;
        } finally {
            loading.value = false;
        }
    };

    return {
        event,
        events,
        registeredUsers,
        participants,
        loading,
        fetchEvents,
        fetchEventDetail,
    };
});